module.exports = __webpack_public_path__ + "static/media/R-360HD_CrossSection.b6832a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-360HD_CrossSection.png
// module id = 481
// module chunks = 0